import type { ReactNode } from 'react';

type NodePopoverRowProps = {
  label: string;
  value: ReactNode;
};

export const NodePopoverRow = ({ label, value }: NodePopoverRowProps) => (
  <li>
    {label}: {value}
  </li>
);
